import React, { useState } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Alert,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // updated
import { sendPasswordResetOtp } from "../../pages/password-reset/passAction";

export const PasswordRestComp = () => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate(); // updated
  const { isLoading, status, message } = useSelector((state) => state.password);

  const handleOnResetSubmit = (e) => {
    e.preventDefault();
    dispatch(sendPasswordResetOtp(email));
  };

  const handleOnChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <Container>
      <Row>
        <Col>
          <h2 className="text-danger text-center" style={{ width: "300px" }}>
            Reset Password
          </h2>
          <hr />
          {message && (
            <Alert variant={status === "success" ? "success" : "danger"}>
              {message}
            </Alert>
          )}
          {isLoading && <Spinner variant="primary" animation="border" />}
          <Form autoComplete="off" onSubmit={handleOnResetSubmit}>
            <Form.Group>
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={email}
                placeholder="Enter your email"
                required
                style={{ maxWidth: "500px" }}
                onChange={handleOnChange}
              />
            </Form.Group>

            <Button className="mt-3" variant="primary" type="submit">
              Send OTP pin
            </Button>
          </Form>
          <hr />
          <span
            onClick={() => navigate("/")} // updated
            style={{
              cursor: "pointer",
              textDecoration: "none",
              color: "red",
              display: "flex",
              justifyContent: "end",
              alignItems: "center", // fixed typo
              marginBottom: 20,
            }}
          >
            Login Now
          </span>
        </Col>
      </Row>
    </Container>
  );
};
